import React from 'react';
import setDefaultValue from '../shared/setDefaultValue';
import cf from '../../utils/cf';
import fp from '../../utils/fp';

export default function genOperationAuth(operationCorrespondRoles, curRole) {
    return (
        <span>
            {
                fp.compose(
                    fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
                    fp.curry(setDefaultValue)('-'),
                    fp.filter(i => !!i),
                    // 获取角色对应操作
                    fp.curry(cf.authDomList)(operationCorrespondRoles)
                )(curRole)
            }
        </span>
    );
}


// WEBPACK FOOTER //
// ./src/components/common/genOperationAuth.js